<script setup lang="ts">
import type { ButtonVariants } from '~ds/components/ui/button'
import type { PaginationListItemProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import { reactiveOmit } from '@vueuse/core'
import { buttonVariants } from '~ds/components/ui/button'
import { cn } from '~ds/lib/utils'
import { PaginationListItem } from 'reka-ui'

const props = withDefaults(defineProps<PaginationListItemProps & {
  size?: ButtonVariants['size'];
  class?: HTMLAttributes['class'];
  isActive?: boolean;
}>(), {
  size: 'icon',
})

const delegatedProps = reactiveOmit(props, 'class', 'size', 'isActive')
</script>

<template>
  <PaginationListItem
    data-slot="pagination-item"
    v-bind="delegatedProps"
    :class="cn(
      buttonVariants({
        variant: isActive ? 'outline' : 'ghost',
        size,
      }),
      'rounded-md',
      props.class)"
  >
    <slot />
  </PaginationListItem>
</template>
